import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const Header = () => {
  const [isNavbarOpen, setIsNavbarOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const toggleNavbar = () => setIsNavbarOpen(!isNavbarOpen);

  const handleNavClick = (hash) => {
    if (location.pathname === '/') {
      const target = document.getElementById(hash);
      if (target) target.scrollIntoView({ behavior: 'smooth' });
    } else {
      window.location.href = `/#${hash}`;
    }
    setIsNavbarOpen(false);
  };

  const isApplyPage = location.pathname === '/apply';

  return (
    <nav
      className={`chi-navbar${scrolled || isApplyPage ? ' chi-navbar--scrolled' : ''}${isNavbarOpen ? ' chi-navbar--open' : ''}`}
    >
      <div className="container">
        <a className="chi-navbar__brand" href="/">
          <img src="/logo.png" alt="C.H.I Logistics" />
        </a>

        <button
          className="chi-navbar__toggler"
          onClick={toggleNavbar}
          aria-label="Toggle navigation"
        >
          <span></span>
          <span></span>
          <span></span>
        </button>

        <div className={`chi-navbar__menu${isNavbarOpen ? ' chi-navbar__menu--open' : ''}`}>
          <ul className="chi-navbar__nav">
            <li>
              <a
                href="#about"
                className="chi-navbar__link"
                onClick={(e) => { e.preventDefault(); handleNavClick('about'); }}
              >
                About Us
              </a>
            </li>
            <li>
              <a
                href="#services"
                className="chi-navbar__link"
                onClick={(e) => { e.preventDefault(); handleNavClick('services'); }}
              >
                Services
              </a>
            </li>
            <li>
              <a
                href="#contact"
                className="chi-navbar__link"
                onClick={(e) => { e.preventDefault(); handleNavClick('contact'); }}
              >
                Contact Us
              </a>
            </li>
            <li>
              <a
                className="chi-navbar__cta"
                href="/apply"
                onClick={() => setIsNavbarOpen(false)}
              >
                Drive For C.H.I.
              </a>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default Header;
